import axios from '../library/axiosConfig'
export  default {
  myCouponBags (data) {
    return axios.post('coupon/myCouponBagOrCoupons', data ,{baseURL: axios.defaults.renterCoupon})
  },
  myCoupons (data) {
    return axios.post('coupon/myCoupons', data, {baseURL: axios.defaults.renterCoupon})
  },
  myCouponBagsBc (data) {
    return axios.post('coupon/findCoupListOfLandlord', {} ,{baseURL: axios.defaults.renterCoupon, params: data})
  },
  getCouponBagDetail (data) {
    return axios.post('coupon/getCouponBagDetail', data ,{baseURL: axios.defaults.renterCoupon})
  },
  /**
   *租客领券
   * @param data
   */
  getRenterCoupon(data) {
    return axios.post('coupon/renterGetCouponForH5', data, {baseURL: axios.defaults.renterCoupon});
  },
  getRenterCouponV2(data) {
    return axios.post('coupon/renterGetCouponVersion2ForH5', data, {baseURL: axios.defaults.renterCoupon, channel: 9});
  },
  /**
   * 8折券领取
   * @param data
   * @returns {AxiosPromise<any>}
   */
  queryHasCoupon(data) {
    return axios.post('coupon/judgeHasgetCoupon', data, {baseURL: axios.defaults.renterCoupon, channel: 9});
  },
  /**
   * 获取卡券分享内容
   */
  getCouponShareInfo() {
    return axios.post('coupon/getShareInfo', {}, {baseURL: axios.defaults.renterCoupon});
  },
  getCouponInCollection (data) {
    return axios.post(`coupon/getCurrentActivities`, data, {baseURL: axios.defaults.renterCoupon});
  },
  /* 卡券 企业、学校定制 */
  // 企业、学校模糊匹配
  searchOrgByKeywords (keywords, merchType) {
    return axios.post(`customization/searchByKeywords`, {
      keywords,
      merchType
    }, {baseURL: axios.defaults.renterCoupon})
  },
  // 通过缩略码查询企业、学校信息
  queryOrgByCode (merchCode, merchType) {
    return axios.post(`/customization/searchByMerchCode?merchCode=${merchCode}&merchType=${merchType}`, {}, {baseURL: axios.defaults.renterCoupon})
  },
  //助力租客领券接口
  helpGetCoupon (data) {
    return axios.post('/coupon/helpGetCoupon', data, {baseURL: axios.defaults.renterCoupon});
  },
  //查询是否助力过
  queryFrendInfo (data) {
    return axios.post('/coupon/queryFrendInfo', data, {baseURL: axios.defaults.renterCoupon});
  },
  //查询租客卡券被助力信息
  queryRenterBeHelpedCount (data) {
    return axios.post('/coupon/queryRenterBeHelpedCount', data, {baseURL: axios.defaults.renterCoupon});
  },
  /**
   * 查询单个活动信息
   * @param {Number} activityId
   */
  findActivityByActiId (activityId) {
    return axios.post('/activity/findActivityByActiId?actiId=' + activityId, null, {baseURL: axios.defaults.renterCoupon})
  },
  judgeHasgetCoupon (data) {
    return axios.post(`/coupon/judgeHasgetCoupon?actiId=${data.activityId}&actiType=${data.actiType}`, null, {baseURL: axios.defaults.renterCoupon})
  },
  renterGetCouponVersion2ForH5 (data) {
    return axios.post(`/coupon/renterGetCouponVersion2ForH5?actiId=${data.activityId}&actiType=${data.actiType}&getCity=${data.cityId}`, null, {baseURL: axios.defaults.renterCoupon})
  },
  /**
   * 咸鱼领取卡券礼包
   */
  receiveCoupons() {
    return axios.get('/prize/receiveCoupons', {baseURL: axios.defaults.mrktWeb})
  }
}



// WEBPACK FOOTER //
// ./src/api/renterCoupon.js